var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10952_55460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0051 0H3.9949C1.78858 0 0 1.78858 0 3.9949V12.0051C0 14.2114 1.78858 16 3.9949 16H12.0051C14.2114 16 16 14.2114 16 12.0051V3.9949C16 1.78858 14.2114 0 12.0051 0Z",
    fill: "url(#paint0_linear_10952_55460)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0051 0H3.9949C1.78858 0 0 1.78858 0 3.9949V12.0051C0 14.2114 1.78858 16 3.9949 16H12.0051C14.2114 16 16 14.2114 16 12.0051V3.9949C16 1.78858 14.2114 0 12.0051 0Z",
    fill: "url(#paint1_radial_10952_55460)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13157 14.0532C6.93146 14.0532 6.37374 13.878 5.40432 13.1772C4.79112 13.9656 2.84934 14.5818 2.76465 13.5276C2.76465 12.7363 2.58945 12.0677 2.39089 11.3377C2.15438 10.4383 1.88574 9.43676 1.88574 7.98554C1.88574 4.51952 4.72981 1.91199 8.09946 1.91199C11.472 1.91199 14.1146 4.648 14.1146 8.01765C14.1259 11.3352 11.4491 14.0355 8.13157 14.0532ZM8.18121 4.90788C6.54019 4.8232 5.26123 5.95908 4.978 7.74026C4.7444 9.21485 5.15904 11.0106 5.51235 11.1041C5.68171 11.1449 6.10803 10.8004 6.37374 10.5347C6.81313 10.8382 7.32478 11.0205 7.8571 11.0632C9.55747 11.145 11.0104 9.85048 11.1245 8.15199C11.191 6.44988 9.88182 5.00821 8.18121 4.9108V4.90788Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10952_55460",
    x1: 1.88555,
    y1: 12.1686,
    x2: 16,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#5533EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9933DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10952_55460",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.380653 -7.02697) rotate(51.356) scale(19.4163 8)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMax);
export default __webpack_public_path__ + "static/media/max.44d08672944812cef70c973f6f5291d5.svg";
export { ForwardRef as ReactComponent };